import { render, staticRenderFns } from "./KelasList.vue?vue&type=template&id=41ce7381&scoped=true"
import script from "./KelasList.vue?vue&type=script&lang=js"
export * from "./KelasList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ce7381",
  null
  
)

export default component.exports